export default __webpack_public_path__ + "static/media/FixedInflationExtensionTemplateLocation.4f210483.sol";